import { render, staticRenderFns } from "./StudentCommentsSlidebar.vue?vue&type=template&id=6904f912"
import script from "./StudentCommentsSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentCommentsSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports